import { CreateReference, getReferenceData, ResourceType } from '@quromedical/fhir-common';
import { LinkTo } from 'navigation';

type Link = Exclude<LinkTo, string>;

type CreatePatientLink = (patientId: string) => Link;

const patientLink: CreatePatientLink = id => ({
  screen: 'Patient',
  params: {
    screen: 'View',
    params: {
      id,
      screen: 'Profile',
    },
  },
});

const patientLinkMap: Partial<Record<ResourceType, CreatePatientLink>> = {
  Patient: patientLink,
  ClinicalImpression: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Notes',
      },
    },
  }),
  Encounter: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Notes',
      },
    },
  }),
  Media: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Medias',
      },
    },
  }),
  Coverage: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Clinical',
      },
    },
  }),
  DiagnosticReport: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'ServiceRequests',
        params: {
          screen: 'List',
        },
      },
    },
  }),
  ServiceRequest: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'ServiceRequests',
        params: {
          screen: 'List',
        },
      },
    },
  }),
  Observation: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Vitals',
      },
    },
  }),
  Task: id => ({
    screen: 'Patient',
    params: {
      screen: 'View',
      params: {
        id,
        screen: 'Tasks',
      },
    },
  }),
};

export const getLinkToPatientResource = (
  patient?: CreateReference,
  target?: CreateReference
): Link | undefined => {
  const patientResource = getReferenceData(patient);
  const targetResource = getReferenceData(target);

  if (!patientResource) {
    return undefined;
  }

  const link: CreatePatientLink =
    (targetResource && patientLinkMap[targetResource.resourceType]) || patientLink;

  if (!link) {
    return undefined;
  }

  return link(patientResource.id);
};
